import { JSX } from 'react';
import { Dayjs } from 'dayjs';
import { mapScheduleDateData } from 'entities/schedulePublic/lib';
import { mappedGroupSchedule, mappedTeacherSchedule } from 'entities/types';
import { DateCard } from 'widgets/schedule/stageSchedule/dateCard';

export const makeDateCards = (
  data: mappedGroupSchedule | mappedTeacherSchedule,
  startDate: Dayjs,
  endDate: Dayjs,
  isScrolledDown: boolean,
): JSX.Element[] => {
  const res: JSX.Element[] = [];

  if (data.length === endDate.diff(startDate, 'day')) {
    const dateDataArray = mapScheduleDateData(startDate, endDate, data);
    data.forEach((_, index) => {
      const dateData = dateDataArray[index];
      res.push(
        <DateCard
          data={dateData}
          isScrolledDown={isScrolledDown}
          key={`${dateData.key}_${index}`}
        />,
      );
    });
  }
  return res;
};
